import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable && <>
        {/* filterModel in KPISet
        <JSONPretty data={filterModel} className="json-wrapper" /> */}
        <Box className="mtska-kpi-set">
            <KPI
                title="AdvertisingCosts"
                icon="faChartSimpleHorizontal"
                dataProviderName={'statisticsviews/item/count/advertisings/advertisingCost'}
                filters={filterModel}
            />
            <KPI
                title="AdvertisingCostsValue"
                icon="faCommentDollar"
                dataProviderName={'statisticsviews/item/sumfinancial/advertisings/advertisingCost/value'}
                format="currency"
                compactformat={false}
                filters={filterModel}
            />
        </Box>
    </>
    )
}

export default KPISet;